var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"white"},[_c('v-spacer'),_c('v-col',{staticClass:"mt-3",attrs:{"cols":"8","lg":"10","xl":"7"}},[_c('p',{staticClass:"red--text text--darken-2"},[_vm._v("* Required fields")])]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }